import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=58a2478f&scoped=true"
import script from "./DropArea.vue?vue&type=script&lang=js"
export * from "./DropArea.vue?vue&type=script&lang=js"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=58a2478f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a2478f",
  null
  
)

export default component.exports